// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desired-edit-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  z-index: 1000;
}

.desired-edit-card {
  width: min(560px, 92vw);
  background: linear-gradient(180deg, #0f172a, #020617);
  color: #fff;
  padding: 28px;
  border-radius: 18px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);
}

.desired-edit-card h2 {
  margin-bottom: 16px;
}

.desired-edit-card label {
  display: block;
  margin-bottom: 6px;
  color: #cbd5f5;
  font-size: 13px;
}

.desired-edit-card input,
.desired-edit-card textarea {
  width: 100%;
  padding: 12px;
  margin-bottom: 14px;
  border-radius: 12px;
  border: 1px solid #1e293b;
  background: #0b1220;
  color: #e5e7eb;
}

.desired-edit-card textarea {
  resize: vertical;
}

.desired-edit-card .button-close {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 10px;
}

.desired-edit-card button {
  padding: 10px 18px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
}

.desired-edit-card button[type="submit"] {
  background: #facc15;
  color: #020617;
  font-weight: 600;
}

.desired-edit-card button[type="button"] {
  background: transparent;
  color: #e5e7eb;
  border: 1px solid #334155;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Masters/DesiredType/EditDesiredType/EditDesiredType.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".desired-edit-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(6px);\n  z-index: 1000;\n}\n\n.desired-edit-card {\n  width: min(560px, 92vw);\n  background: linear-gradient(180deg, #0f172a, #020617);\n  color: #fff;\n  padding: 28px;\n  border-radius: 18px;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);\n}\n\n.desired-edit-card h2 {\n  margin-bottom: 16px;\n}\n\n.desired-edit-card label {\n  display: block;\n  margin-bottom: 6px;\n  color: #cbd5f5;\n  font-size: 13px;\n}\n\n.desired-edit-card input,\n.desired-edit-card textarea {\n  width: 100%;\n  padding: 12px;\n  margin-bottom: 14px;\n  border-radius: 12px;\n  border: 1px solid #1e293b;\n  background: #0b1220;\n  color: #e5e7eb;\n}\n\n.desired-edit-card textarea {\n  resize: vertical;\n}\n\n.desired-edit-card .button-close {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.desired-edit-card button {\n  padding: 10px 18px;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n}\n\n.desired-edit-card button[type=\"submit\"] {\n  background: #facc15;\n  color: #020617;\n  font-weight: 600;\n}\n\n.desired-edit-card button[type=\"button\"] {\n  background: transparent;\n  color: #e5e7eb;\n  border: 1px solid #334155;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
